import { render } from "./App.vue?vue&type=template&id=e551e780"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=e551e780&lang=css"

import exportComponent from "C:\\Users\\Admin\\Desktop\\Development\\saska-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__